export const paymentMethods = [
  {
    id: 'apple',
    name: 'Apple Pay',
    src: '/assets/images/pay-option-apple.svg',
  },
  {
    id: 'google',
    name: 'Google Pay',
    src: '/assets/images/pay-option-google.svg',
  },
  {
    id: 'afterpay',
    name: 'Afterpay',
    src: '/assets/images/pay-option-afterpay.svg',
  },
  {
    id: 'mastercard',
    name: 'Mastercard',
    src: '/assets/images/pay-option-mastercard.svg',
  },
  {
    id: 'amex',
    name: 'American Express',
    src: '/assets/images/pay-option-amex.svg',
  },
  {
    id: 'visa',
    name: 'Visa',
    src: '/assets/images/pay-option-visa.svg',
  },
];
